<template>
  <div>
       <div class="page-header">
              <h1>
                Garage Door Extension Springs
              </h1>
            </div>
            <div class="block block-border-bottom-grey block-pd-sm">

              <div class="row">
                <div class="col-md-8">
                  <img src="../assets/img/misc/garage-door-extension-springs.jpg" alt="shelves of garage door extension springs" class="img-responsive img-thumbnail m-b hidden-xs">
                </div>
                <div class="col-md-4">
                  <h4 class="block-title">
                    Manufacturing capabilities
                  </h4>
                  <ul class="manufacturing-capabilities">
                    <li>Standard oil-tempered, hard drawn and galvanized wire diameters in stock up to .625"</li>
                    <li>Stock extension springs for 7’, 8’, 9’, and 10’ doors</li>
                    <li>Springs for door weights ranging from 40 – 400 lbs.</li>
                    <li>Heat applied black coating applied after stress relieving process</li>
                    <li>Various ends options – double coil loop, single hook, clipped</li>
                    <li>Custom ends available</li>
                    <li>Custom packaging upon request</li>
                  </ul>
                </div>
              </div>
              <div class="row">
                <div class="col-md-8 col-xs-12">
                  <p class="iso-footer">
                    We are an ISO 9001 certified manufacturer of garage door springs. We supply to certified garage door dealers, wholesalers,
                    and manufacturers.
                  </p>
                </div>
              </div>
            </div>
          </div>
</template>

<script>
export default {
  name: "GarageDoorSpringsExtension"
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/GarageDoorSpringsExtension.vue